module.exports = __webpack_public_path__ + "chef-b570c4e5a80be867b5ca0fed3367c0be.svg";